// extracted by mini-css-extract-plugin
module.exports = {"container":"TournamentTile_container__32F4u","logo":"TournamentTile_logo__Zetis"};